<template>
  <div
    class="technology-screen"
    data-sidebar="6"
    data-position="0"
    data-name="人文"
  >
    <PlusImage class="technology-bg" :src="technology1Img" />
    <div class="technology-screen-wrap">
      <div class="technology-screen-title ffm600" v-animate>
        <p>科技照亮</p>
        <p>每一个日常</p>
      </div>
      <div v-animate v-if="isMobile" class="description ffm400">
        vivo相信：科技的终点是让人感受幸福，抵达美好。我们希望每个人都能通过科技创新，看到爱，听到爱，表达爱，让AI触手可及。
      </div>
      <div v-animate v-else class="description ffm400">
        vivo相信：科技的终点是让人感受幸福，抵达美好。<br />我们希望每个人都能通过科技创新，看到爱，听到爱，表达爱，让AI触手可及。
      </div>
      <div v-animate class="more ffm600">
        <a
          href="https://wuzhangai.vivo.com/"
          target="_blank"
          data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',module:'人文',button_name:'点击了解更多'}}"
          >点击了解更多 ></a
        >
      </div>

      <div class="a11y-wrap">
        <div class="a11y-item" v-animate>
          <div class="a11y-title ffm500">vivo听说</div>
          <div class="a11y-subtitle ffm600">分清谁在说话</div>
          <div class="a11y-desc ffm400">
            整合声音记忆与自定义听声功能，可精准识别名字呼唤，清晰分辨说话人身份，文字与姓名实时呈现，交流更顺畅自然。
          </div>
          <PlusImage
            v-if="isMobile"
            class="a11y-img"
            :src="TECHNOLOGY.vivoSeeH5"
            alt=""
          />
          <PlusImage
            v-else-if="isPad"
            class="a11y-img"
            :src="TECHNOLOGY.vivoSeePad"
            alt=""
          />
          <template v-else>
            <PlusImage class="a11y-img-pc" :src="TECHNOLOGY.vivoSee" alt="" />
          </template>
        </div>
        <div class="a11y-item" v-animate>
          <div class="a11y-title ffm500">助听器蓝牙直连</div>
          <div class="a11y-subtitle ffm600">听得更清、更远</div>
          <div class="a11y-desc ffm400">
            vivo手机可直连蓝牙助听器，支持LE音频，音质更好，长距离也不断连。
          </div>
          <PlusImage
            v-if="isMobile"
            class="a11y-img"
            :src="TECHNOLOGY.hearingAidConnectH5"
            alt=""
          />
          <PlusImage
            v-else-if="isPad"
            class="a11y-img a11y-img-connect"
            :src="TECHNOLOGY.hearingAidConnectPad"
            alt=""
          />
          <template v-else>
            <PlusImage
              class="a11y-img-pc"
              :src="TECHNOLOGY.hearingAidConnect"
              alt=""
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { TECHNOLOGY } from "@/config/image.js";
import { initExposureTrack } from "@/utils/track.js";

export default {
  name: "TechnologyIlluminate",
  data() {
    return {
      TECHNOLOGY,
      video: "https://h5-inside.vivo.com.cn/pcvivo/video6/a11y1.mp4",
    };
  },
  computed: {
    ...mapGetters(["isPC", "isPad", "isMobile"]),
    technology1Img() {
      if (this.isPad) {
        return this.TECHNOLOGY.technology1Pad;
      } else if (this.isMobile) {
        return this.TECHNOLOGY.technology1H5;
      } else {
        return this.TECHNOLOGY.technology1;
      }
    },
  },
  mounted() {
    initExposureTrack(".technology-screen")();
  },
};
</script>

<style lang="scss" scoped>
.technology-screen {
  width: 100%;
  height: 1180 * $px1920vw + vw;
  padding-top: 140 * $px1920vw + vw;
  position: relative;

  .technology-bg {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    z-index: 1;
  }

  .technology-screen-wrap {
    position: relative;
    z-index: 2;
    font-size: 0;
    .technology-screen-title {
      width: fit-content;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 96 * $px1920vw + vw;
      line-height: 115.2 * $px1920vw + vw;
      text-align: center;
      background: linear-gradient(270deg, #000000 0%, #5b4a48 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .description {
      font-size: 18 * $px1920vw + vw;
      line-height: 25.2 * $px1920vw + vw;
      text-align: center;
      color: rgba(0, 0, 0, 0.8);
      width: 743 * $px1920vw + vw;
      margin: 24 * $px1920vw + vw auto 0 auto;
    }

    .more {
      font-size: 18 * $px1920vw + vw;
      line-height: 25.2 * $px1920vw + vw;
      text-align: center;
      color: #000000;
      margin-top: 24 * $px1920vw + vw;
      cursor: pointer;
    }

    .a11y-wrap {
      width: 1200 * $px1920vw + vw;
      display: flex;
      justify-content: space-between;
      margin: 86 * $px1920vw + vw auto 0 auto;

      .a11y-item {
        width: 588 * $px1920vw + vw;
        height: 600 * $px1920vw + vw;
        border-radius: 24 * $px1920vw + vw;
        background: #fff;
        text-align: left;
        overflow: hidden;
        position: relative;
        padding-top: 48 * $px1920vw + vw;

        .a11y-title {
          font-size: 24 * $px1920vw + vw;
          line-height: 29 * $px1920vw + vw;
          color: #0f77ff;
          padding-left: 48 * $px1920vw + vw;
          z-index: 2;
          position: relative;
        }

        .a11y-subtitle {
          font-size: 32 * $px1920vw + vw;
          line-height: 39 * $px1920vw + vw;
          color: #000000;
          margin-top: 8 * $px1920vw + vw;
          padding-left: 48 * $px1920vw + vw;
          z-index: 2;
          position: relative;
        }

        .a11y-desc {
          width: 498 * $px1920vw + vw;
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: rgba(0, 0, 0, 0.6);
          margin-top: 16 * $px1920vw + vw;
          padding-left: 48 * $px1920vw + vw;
          box-sizing: content-box;
          z-index: 2;
          position: relative;
        }

        .a11y-img-pc {
          width: 588 * $px1920vw + vw;
          height: 600 * $px1920vw + vw;
          position: absolute;
          top: 0;
          left: 0;
        }

        .a11y-video {
          width: 150 * $px1920vw + vw;
          height: 330 * $px1920vw + vw;
          object-fit: cover;
          margin: 35 * $px1920vw + vw auto 0 auto;
          display: block;
          z-index: 2;
          position: relative;
          border-radius: 10 * $px1920vw + vw;
        }
      }
    }
  }
}

.isPad {
  .technology-screen {
    width: 100%;
    height: 686 * $px676vw + vw;
    padding-top: 66 * $px676vw + vw;
    position: relative;

    .technology-bg {
      width: 100%;
      left: 0;
      top: 0;
      position: absolute;
      z-index: 1;
    }

    .technology-screen-wrap {
      position: relative;
      z-index: 2;
      .technology-screen-title {
        font-size: 42 * $px676vw + vw;
        line-height: 49 * $px676vw + vw;
        background: linear-gradient(270deg, #000000 0%, #5b4a48 100%);
        -webkit-background-clip: text;
        background-clip: text;
        text-fill-color: transparent;
      }

      .description {
        font-size: 12 * $px676vw + vw;
        line-height: 16 * $px676vw + vw;
        text-align: center;
        color: rgba(0, 0, 0, 0.8);
        margin: 24 * $px676vw + vw auto 0 auto;
        width: auto;
      }

      .more {
        font-size: 12 * $px676vw + vw;
        line-height: 14 * $px676vw + vw;
        text-align: center;
        color: #000000;
        margin-top: 24 * $px676vw + vw;
        cursor: pointer;
      }

      .a11y-wrap {
        width: 596 * $px676vw + vw;
        display: flex;
        justify-content: space-between;
        margin: 81 * $px676vw + vw auto 0 auto;

        .a11y-item {
          width: 288 * $px676vw + vw;
          height: 360 * $px676vw + vw;
          border-radius: 10 * $px676vw + vw;
          background: #f5f5f7;
          padding-top: 28 * $px676vw + vw;
          overflow: hidden;

          .a11y-title {
            font-size: 12 * $px676vw + vw;
            line-height: 14 * $px676vw + vw;
            color: #0f77ff;
            padding-left: 22 * $px676vw + vw;
          }

          .a11y-subtitle {
            font-size: 20 * $px676vw + vw;
            line-height: 23 * $px676vw + vw;
            margin-top: 6 * $px676vw + vw;
            padding-left: 22 * $px676vw + vw;
          }

          .a11y-desc {
            width: 248 * $px676vw + vw;
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            color: rgba(0, 0, 0, 0.8);
            margin-top: 12 * $px676vw + vw;
            padding-left: 22 * $px676vw + vw;
          }

          .a11y-img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }
    }
  }
}

.isMobile {
  .technology-screen {
    height: auto;
    padding-top: 42 * $px360vw + vw;
    .technology-bg {
      width: 100%;
      height: 337 * $px360vw + vw;
      left: 0;
      top: 0;
      position: absolute;
      z-index: 1;
    }
    .technology-screen-wrap {
      .technology-screen-title {
        display: inline-block;
        font-size: 42 * $px360vw + vw;
        line-height: 49 * $px360vw + vw;
      }

      .description {
        font-size: 12 * $px360vw + vw;
        line-height: 16 * $px360vw + vw;
        width: 295 * $px360vw + vw;
        margin: 12 * $px360vw + vw auto 0 auto;
      }

      .more {
        font-size: 12 * $px360vw + vw;
        line-height: 14 * $px360vw + vw;
        color: rgba(0, 0, 0, 0.8);
        margin-top: 18 * $px360vw + vw;
      }

      .a11y-wrap {
        width: 100%;
        display: inline-block;
        margin: 48 * $px360vw + vw 0 0 0;
        background-color: #fff;

        .a11y-item {
          width: 320 * $px360vw + vw;
          height: 360 * $px360vw + vw;
          margin: 0 auto;
          border-radius: 10 * $px360vw + vw;
          background: #f5f5f7;
          margin-bottom: 20 * $px360vw + vw;
          padding-top: 28 * $px360vw + vw;
          padding-left: 22 * $px360vw + vw;
          padding-right: 20 * $px360vw + vw;

          .a11y-title {
            font-size: 12 * $px360vw + vw;
            line-height: 14 * $px360vw + vw;
            padding-left: 0;
          }

          .a11y-subtitle {
            font-size: 20 * $px360vw + vw;
            line-height: 23 * $px360vw + vw;
            margin-top: 6 * $px360vw + vw;
            padding-left: 0;
            color: rgba(0, 0, 0, 1);
          }

          .a11y-desc {
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            color: rgba(0, 0, 0, 0.8);
            width: auto;
            padding-left: 0;
            margin: 12 * $px360vw + vw auto 0 auto;
          }

          .a11y-img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }
    }
  }
}

@media (prefers-color-scheme: dark) {
  .isMobile {
    .technology-screen {
      .technology-screen-wrap {
        .description {
          color: rgba(0, 0, 0, 0.8);
        }
        .a11y-wrap {
          background: #222;
          .a11y-item {
            background: #000;
            .a11y-subtitle {
              color: #fff;
            }
            .a11y-desc {
              color: #eee;
            }
          }
        }
      } 
    }
  }

}
</style>